//任务管理
export const task = '/erp/task/query'; //列表查询